import {Component} from "react";
import * as React from "react";

import School from "../models/School";
import TableCell from "./TableCell";
import {friendlySchoolName, unfriendlySchoolName} from "../utils/Utils";

interface SchoolCellProps
{
    schoolKey: {tenantName?: string,tenantId?: string, schoolCode?: string}
    school?: School;
    enableLink?: boolean;
    linkTo?: string;
    flex?: number;
}


export default class SchoolCell extends Component<SchoolCellProps>
{
    public componentDidMount() {

    }

    public render() {

        const unfriendlyName = this.props.school ? unfriendlySchoolName(this.props.school) : unfriendlySchoolName(this.props.schoolKey);
        const friendlyName = this.props.school ? friendlySchoolName(this.props.school) : unfriendlyName;

        let to = "";

        if (this.props.linkTo) {
            to = this.props.linkTo;
        }
        else {
            to = this.props.school ? `/cdb-admin/schools/${this.props.school.tenantId}/${this.props.school.schoolCode}` : ""
        }

        return (
            <TableCell flex={this.props.flex} to={to} enableLink={this.props.enableLink}>
                <span>{friendlyName}</span>
                <span className="cdb-table__extra-detail">{unfriendlyName}</span>
            </TableCell>
        );
    }
}